import PhotoSwipeLightbox from 'photoswipe/lightbox';

/* 
	Implementa galeria photoswipe en todos los containers que tengan la clase .photoswipe-gallery 
	https://photoswipe.com/getting-started/
*/
window.addEventListener('DOMContentLoaded', () => {
	
	setTimeout(() => {
		const galleries = document.querySelectorAll(".photoswipe-gallery");
		InitiatePhotoSwipe(galleries);

		const allItems = document.querySelectorAll('.photoswipe-item');
		if (allItems) addAnimationOnItems(allItems);
	}, 2000)


});

const addAnimationOnItems = (allItems) => {

	function onIntersection(entries, observer) {
		entries.forEach(entry => {
			if (entry.isIntersecting && entry.intersectionRatio >= 0.2) {
				entry.target.classList.add('photoswipe-item--visible');
				observer.unobserve(entry.target); // Stop observing this element after first trigger
			}
		});
	}
	
	const observer = new IntersectionObserver(onIntersection, {
		threshold: 0.2, // Trigger when 20% of the element is visible
	});
	
	allItems.forEach(element => observer.observe(element));
}



const InitiatePhotoSwipe = (galleries) => {

	try {
		if (galleries.length === 0) return;

		const windowHeight = window.innerHeight;
	
		for (const gallery of galleries) {
	
			if (!gallery) continue;
	
			const id = gallery?.id?.trim();
			if (!id) continue;
	
			const lightbox = new PhotoSwipeLightbox({
				gallery: `#${id}`, 
				children: '.slick-slide:not(.slick-cloned) a', 
				showHideAnimationType: 'fade',
				pswpModule: () => import('photoswipe')
			});
	
			if (!lightbox) continue;
			
			const galleryImgs = gallery.querySelectorAll('.slick-slide:not(.slick-cloned) a')
			if (!galleryImgs) continue;
	
			galleryImgs.forEach((img) => {
				const imgHeight = parseInt(img.getAttribute('data-pswp-height')) || 800;
				const imgWidth = parseInt(img.getAttribute('data-pswp-width')) || 400;		
				
				if (imgHeight && imgWidth) {
					img.setAttribute('data-pswp-height', windowHeight);
					img.setAttribute('data-pswp-width', imgWidth * (windowHeight / imgHeight));
				}
			})
	
			lightbox.init()
		}
	} catch (error) {
		console.error("Error en InitiatePhotoSwipe: ", error)
	}
}